import React, { Component } from 'react';
import Input from 'Components/Input';
import Select from 'react-select';
import Button from 'Components/Button';

class RetriggerEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emails: props.reminderEmailDetails && Object.keys(props.reminderEmailDetails).length > 0 ? props.reminderEmailDetails.reminder_emails : [],
            url: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.reminderEmailDetails && Object.keys(nextProps.reminderEmailDetails).length > 0) {
            const { emails } = nextProps.reminderEmailDetails.reminder_emails;
            this.setState({ emails });
        }
    }


    onHandleChange = (id, evt) => {
        if(evt.target.value){
            let data = evt.target.value.split(',');
            let { emails} = this.state;
            if(id === 'emails') {
                for(var i in data) {
                    if(data[i].trim()){
                        emails.push(data[i].trim());
                    }
                }
            } 
            this.setState({ emails });
        }
    }

    onChange = (id, options) => {
        let emails = [];
        
        if(id === 'emails') {
            for(var i in options) {
                emails.push(options[i].label);
           }
        }
       this.setState({ emails });
    }

    onSave = () => {
        this.props.onSaveSharedDetails(this.state.emails);
        this.props.hideOverlay();
    }

    render() {
        const { emails } = this.state;
        return (
            <div className={'col-1 share'}>
                <div className={'mt-10 ml-25'}>
                    <label>Email Ids (comma separated)</label>
                    <Select className={'wt-300'} isMulti value={emails.length > 0 ? emails.map(val => { return { label : val, value: val } } ) : null} onBlur={this.onHandleChange.bind(this, 'emails')} isClearable={true} onChange={this.onChange.bind(this, 'emails')} placeholder={'Email Id'}/>
                </div>
                
                <div className={'mt-20'}>
                    <div className={'button-outlined share-button wt-100 tCenter fRight mr-40'} onClick={this.onSave}>Send</div>
                    <div className={'button-outlined share-button wt-100 tCenter fRight mr-20'} onClick={this.props.hideOverlay}>Cancel</div>  
                </div>
            </div>
        )
    }
}

export default RetriggerEmail;
